import React, { useState, useEffect } from "react";
import Dropdown from "../../../components/inputs/Dropdown";
import { BackButton } from "../../../components/btn/Buttons";
import PageHeading from "../../../components/PageHeading";
import Table from "../../../components/table/Table";
import { base_url, getFinancialYearOptions } from "../../../utils/utils";
import SmallModal from "../../../components/modal/SmallModal";
import { Pagination2 } from "../../../components/pagination/pagination";
import { useSelector } from "react-redux";

const CapitalAccReport = () => {
  // State variable for the selected financial year
  const [selectedYear, setSelectedYear] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [capitalReportData, setCapitalReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alerts, setAlerts] = useState(false);
  const [alertsMess, setAlertsMess] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [entries, setEntries] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const { profile_data } = useSelector((state) => state.profile);
  // Get agency ID from localStorage
  const getAgencyId = () => {
    const userIdString = localStorage.getItem("userId");
    if (userIdString) {
      const userData = JSON.parse(userIdString);
      return userData?.aid;
    }
    return null;
  };

  // Fetch capital report data from API
  const fetchCapitalReport = async (page = 1, year = selectedYear) => {
    try {
      setLoading(true);
      const agencyId = getAgencyId();

      if (!agencyId) {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "red", textAlign: "left" }}>
            <p>Error: Agency ID not found in localStorage</p>
          </div>
        );
        setLoading(false);
        return;
      }

      // Create FormData
      const formData = new FormData();
      formData.append("action", "list");
      formData.append("agencyid", agencyId);
      formData.append("page", page);
      formData.append("limit", parseInt(entries));
      formData.append("FY", year);

      // Make API call
      const response = await fetch(
        `${base_url}financial_reports/capital_report.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result.success && result.data) {
        setCapitalReportData(result.data);
        setTotalCount(result.totalcount || 0);
        setPageNo(page);
        setModalOpen(true);
      } else {
        setAlerts(true);
        setAlertsMess(
          <div style={{ color: "orange", textAlign: "left" }}>
            <p>{result.message || "No capital report data found"}</p>
          </div>
        );
        setCapitalReportData([]);
      }
    } catch (error) {
      console.error("Error fetching capital report:", error);
      setAlerts(true);
      setAlertsMess(
        <div style={{ color: "red", textAlign: "left" }}>
          <p>Error: {error.message || "Failed to fetch capital report"}</p>
        </div>
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle year change
  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    // Automatically fetch data when year is selected
    if (year) {
      fetchCapitalReport(1, year);
    }
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setPageNo(pageNumber);
    fetchCapitalReport(pageNumber, selectedYear);
  };

  return (
    <div className="container">
      <PageHeading
        title={"CAPITAL REPORT"}
        right={
          <>
            <BackButton />
          </>
        }
      />
      <div style={{ height: "10px" }}></div>
      <div className="df mt10 gap10">
        <div style={{ width: "180px" }}>
          <Dropdown
            label={"FINANCIAL YEAR"}
            value={selectedYear}
            onChange={handleYearChange}
            options={
              <>
                <option value="">SELECT</option>
                {getFinancialYearOptions(profile_data?.CREATED_DATE)?.map(
                  (v, index) => (
                    <option key={index} value={v}>
                      {v}
                    </option>
                  )
                )}
              </>
            }
          />
        </div>

        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <button
            className="GENERATE-BTN"
            onClick={() => fetchCapitalReport(1)}
            disabled={loading}
          >
            {loading ? "LOADING..." : "SEARCH"}
          </button>
        </div>
      </div>
      <div style={{ height: "10px" }}></div>
      {modalOpen && (
        <div>
          <Table
            mt={5}
            headData={[
              "PARTNER NAME",
              "OPENING BALANCE",
              "TOTAL ADDITIONS",
              "TOTAL WITHDRAWALS",
              "TOTAL EXIT PAYOUTS",
              "CLOSING BALANCE",
            ]}
            body={
              <>
                {capitalReportData && capitalReportData.length > 0 ? (
                  capitalReportData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.PARTNER_NAME}</td>
                      <td>
                        ₹{parseFloat(item.OPENING_BALANCE).toLocaleString()}
                      </td>
                      <td>
                        ₹{parseFloat(item.TOTAL_ADDITIONS).toLocaleString()}
                      </td>
                      <td>
                        ₹{parseFloat(item.TOTAL_WITHDRAWALS).toLocaleString()}
                      </td>
                      <td>
                        ₹{parseFloat(item.TOTAL_EXIT_PAYOUTS).toLocaleString()}
                      </td>
                      <td>
                        ₹{parseFloat(item.CLOSING_BALANCE).toLocaleString()}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      {loading ? "Loading..." : "No data found"}
                    </td>
                  </tr>
                )}
              </>
            }
          />
          <Pagination2
            top={true}
            bottom={true}
            totalCount={totalCount}
            pageNo={pageNo}
            setPageNo={handlePageChange}
            entries={entries}
            setEntries={setEntries}
            search={false}
            count={5}
          />
        </div>
      )}
      {alerts && (
        <SmallModal
          isOpen={alerts}
          setIsOpen={setAlerts}
          title={"Alert"}
          mess={alertsMess}
          okbtn={setAlertsMess}
        />
      )}
    </div>
  );
};

export default CapitalAccReport;
